import { connect } from 'react-redux';

import ManualActions from 'app/redux/manual/actions';
import On9Popup from './On9Popup';

const mapStateToProps = null;
const mapDispatchToProps = {
  fetchManual: ManualActions.fetchManual,
};

// connect with redux
export default connect(mapStateToProps, mapDispatchToProps)(On9Popup);
